// Section 8: per-season job risks (injury, death, illness, animal attack), rolled for everyone
// who worked this season. Probabilities go through the pipeline (work intensity, escorts, threat).
import type { JobRiskKind, Person, PhaseContext } from '../../core/types';
import { killPerson } from '../shared/death';
import { applyDelta } from '../shared/deltas';
import { num } from '../shared/value';

const ORDER: readonly JobRiskKind[] = ['death', 'injury', 'animal', 'illness'];

export function rollRisks(ctx: PhaseContext, workers: readonly Person[]): void {
  for (const worker of workers) {
    const def = ctx.registry.jobs[worker.job];
    for (const risk of ORDER) {
      if (def.risks[risk] === undefined) continue;
      if (ctx.draft.people[worker.id] === undefined) break;
      const p = num(ctx, { kind: 'jobRisk', personId: worker.id, jobId: worker.job, risk });
      const roll = ctx.rng.chance(p);
      if (risk === 'death')
        ctx.report.current.expectedDeaths += ctx.mode === 'projection' ? roll : 0;
      if (!ctx.rng.happened(roll)) continue;
      switch (risk) {
        case 'death':
          killPerson(ctx, worker.id, worker.job === 'hunter' ? 'wild-animal' : 'injury');
          break;
        case 'injury':
        case 'animal':
          applyDelta(ctx, {
            kind: 'injure',
            personId: worker.id,
            source: `job:${worker.job}:${risk}`,
          });
          break;
        case 'illness':
          if (def.riskIllness !== null) {
            applyDelta(ctx, {
              kind: 'sicken',
              personId: worker.id,
              illnessId: def.riskIllness,
              source: `job:${worker.job}`,
            });
          }
          break;
      }
    }
  }
}
